import React from 'react';
import { TextButton } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import GmailIcon from '../../assets/images/gmail.svg';
import OutlookIcon from '../../assets/images/outlook.svg';

const EmailClientButton: React.FC<{
  provider: 'gmail' | 'outlook';
  email: string;
  onClientClick: (provider: string) => void;
}> = ({ provider, email, onClientClick }) => {
  const { t } = useTranslation();

  const config = {
    gmail: {
      icon: <GmailIcon width={16} height={16} />,
      translationKey: 'emailConfirmation.signUp.link.openGmail',
      onClick: () => {
        onClientClick(provider);
        const isGmailUser = email.includes('@gmail.com');
        const searchQuery = encodeURIComponent(
          'from:(wix-team@notifications.wix.com) in:anywhere newer_than:1h',
        );
        const gmailUrl = isGmailUser
          ? `https://mail.google.com/mail/u/${email}/#search/${searchQuery}`
          : `https://mail.google.com/mail/#search/${searchQuery}`;
        window.open(gmailUrl, '_blank');
      },
    },
    outlook: {
      icon: <OutlookIcon width={16} height={16} />,
      translationKey: 'emailConfirmation.signUp.link.openOutlook',
      onClick: () => {
        onClientClick(provider);
        const outlookUrl = 'https://outlook.live.com/mail/0/';
        window.open(outlookUrl, '_blank');
      },
    },
  };

  const { icon, translationKey, onClick } = config[provider];

  return (
    <TextButton
      size="small"
      skin="dark"
      underline="always"
      onClick={onClick}
      prefixIcon={icon}
      gap="8px"
      weight="normal"
      style={{ color: 'rgb(89, 93, 112)' }}
    >
      {t(translationKey)}
    </TextButton>
  );
};

export default EmailClientButton;
